<template>
  <div>
    <el-form :model="form" :inline="true" size="mini">
      <el-form-item style="float: right;">
        <el-link
          v-show="false"
          type="primary"
          :underline="false"
          @click="collapse = !collapse"
          style="margin-right: 10px;"
          >{{ collapse ? "折叠" : "展开" }}</el-link
        >
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button type="warning" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="日期：" prop="auditEndTime">
        <el-date-picker
          v-model="dataBox"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:350px"
        >
        </el-date-picker>
      </el-form-item>

      <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse"></div>
      </transition>
    </el-form>
  </div>
</template>

<script>
import moment from "moment";
export default {
  model: {
    prop: "formData",
    event: "input"
  },
  props: ["formData"],
  data() {
    return {
      collapse: false,
      form: {},
      dataBox: []
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.dataBox = []
    this.onSearch();
  },
  methods: {
    onSearch() {
      if(this.dataBox.length !=0){
       this.form.startDate =
        moment(this.dataBox[0]).format("YYYY-MM-DD") + " 00:00:00";
      this.form.endDate =
        moment(this.dataBox[1]).format("YYYY-MM-DD") + " 23:59:00";
      }
      this.$emit("search", this.form);
    },
    onReset() {
      this.form = {};
      this.$nextTick(_ => {
        this.onSearch();
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
>>> .el-form
  width 100%
  margin-top 5px
>>> .el-form-item
  margin-bottom 5px !important
.search-header-collapse
  position absolute
  background-color #ffffff
  width 100%
  left 0px
  padding 10px 10px 0
  margin-top -5px
  box-sizing border-box
  z-index 999
  box-shadow 0px 5px 5px rgba(0,0,0,.1)

>>> .table-input input
  height 18px
  line-height 18px
  padding 0 10px
  text-align right
  width 45px
</style>
